export default (key, list = [], fallbackValue = key) => {
  if (!key || !list || !Array.isArray(list)) return fallbackValue || '';

  const foundCurrency = list.find((currency) => currency.value === key);

  return foundCurrency ? foundCurrency.name : fallbackValue;
};
